/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
/* global gettext */
import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { reduxForm, Field } from 'redux-form';

import { isPending } from 'consts/requestStates';
import { TENANT_USER_ROLES } from 'consts/userRoles';
import FormError from 'components/form/FormError';
import SubmitButton from 'components/form/SubmitButton';
import TenantConfigFields from './TenantConfigFields';
import UsersFields from './UsersFields';


export const EditTenantForm = ({
  requestState,
  handleSubmit,
  onCancel,
  invalid,
  initialValues,
  disabled,
  isGa,
  anyUsersFailedCreation,
  hideUser,
  setUserFieldCount,
  userCount,
  form,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <label htmlFor="salesforce_id">{gettext('SalesForce ID')}</label>
      <FormError name="salesforce_id" requestState={requestState} />
      <Field
        component="input"
        type="text"
        name="salesforce_id"
        placeholder={gettext('SalesForceID (optional)')}
      />

      <label htmlFor="name">{gettext('Client Name')}</label>
      <FormError name="name" requestState={requestState} />
      <Field
        component="input"
        type="text"
        name="name"
        placeholder={gettext('A name for your client')}
        disabled={!isGa}
      />

      <label htmlFor="jhana_company_id">{gettext('Jhana Company ID')}</label>
      <FormError name="jhana_company_id" requestState={requestState} />
      <Field
        component="input"
        type="text"
        name="jhana_company_id"
        placeholder={gettext('Jhana Company ID')}
        readonly="true"
      />

      <hr />

      <TenantConfigFields
        requestState={requestState}
        disabled={disabled}
        isGa={isGa}
        form={form}
        isEditMode
      />

      <UsersFields
        requestState={requestState}
        roleOptions={TENANT_USER_ROLES}
        initialValues={initialValues.users}
        disabled={disabled}
        editing
        showStatus
        showEmailCheckbox
        editableFields={['role']}
        anyFailedCreation={anyUsersFailedCreation}
        hideUser={hideUser}
        setUserFieldCount={setUserFieldCount}
        userCount={userCount}
      />

      <FormError name="non_field_errors" requestState={requestState} />

      <button
        type="button"
        className="button secondary"
        onClick={onCancel}
        disabled={isPending(requestState)}
      >
        {gettext('Cancel')}
      </button>

      <SubmitButton
        disabled={disabled}
        valid={!invalid}
        onClick={handleSubmit}
        pending={isPending(requestState)}
        pendingText={gettext('Updating...')}
      >
        {gettext('Update')}
      </SubmitButton>

    </form>
  </div>
);

EditTenantForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  requestState: ImmutablePropTypes.map.isRequired,
  invalid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  isGa: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  anyUsersFailedCreation: PropTypes.bool.isRequired,
  hideUser: PropTypes.func.isRequired,
  setUserFieldCount: PropTypes.func.isRequired,
  userCount: PropTypes.number.isRequired,
};

export default reduxForm({
  form: 'editTenantSettings',
  enableReinitialize: true,
})(EditTenantForm);
